import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { ProductCard } from './product-card';
export const ProductGrid = ({ products, className }) => {
    if (!products || products.length === 0) {
        return null;
    }
    const displayProducts = products.slice(0, 6);
    return (_jsx("div", { className: cn('my-3 -mx-1 w-full overflow-x-auto', className), children: _jsx("div", { className: "flex gap-3 px-1 pb-2", children: displayProducts.map((product) => (_jsx(ProductCard, Object.assign({}, product), product.id))) }) }));
};
